import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import config from "../config";
import SucessMessage from "./shared/SucessMessage";
import Pagination  from "../common/Pagination";

function Locations() { const [selectedPopoverId, setSelectedPopoverId] = useState(null);        
    const [locations, setLocationsData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const limit = 10; // Number of items per page

    useEffect(() => {
        // Fetch data from the API
      
        axios.post(`${config.backendUrl}/admin/locations`,{    params: {
          page: currentPage,
        
        },}, {
          headers: {
            'token': localStorage.getItem('token'), // Example authorization header
            'Content-Type': 'application/json', // Example content type header
            // Add more headers as needed
          }
          })
        .then(response => {
          // Handle response
          setLocationsData(response.data.data);
          setTotalPages(Math.ceil(response.data.total_count / limit));
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
      
      
      }, [currentPage, limit]); // Empty dependency array means this effect runs only once on component mount

      const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
      };

  return (
    <div className="pt-[70px]">
     
       <div className="flex justify-between items-center">
              <div>
                <h2>Locations</h2>
                <div className="breadcrumbs">
                  <Link to="/admin/dashboard">Home</Link>
                  <span>{'>'} </span>Locations
                </div>
              </div>
              <div>
                <Link to="/admin/add-location">
                  <button className="genreport-btn">Add Location</button>
                </Link>
              </div>
            </div>
     
      <div className="flex justify-between items-center"> 
       
        <div>
      
      </div>
      </div>
      <div className="whitebox">
        <div>
          <table className="tablegrid" width={"100%"}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Location Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {locations.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td className="redfont">{item.name}</td>
                  <td>Edit</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-between">
          <div> </div>
          {/* <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
             /> */}

        </div>
    </div>
  )
}

export default Locations    